function common_js(){
 jQuery('.index .blog-image').matchHeight();
  jQuery('.index .sub_title').matchHeight();
  jQuery('.index .featured-blog-section').find('.excerpt').matchHeight();
}
jQuery(document).ready(function(){
                       
   common_js();
  //jQuery('.card-brand').matchHeight();                   
                       
});
jQuery(document).resize(function(){
  common_js();
});